export const values = [
  {
    id: 1,
    desc: "Descubrimos la esencia única de cada marca, convirtiéndola en campañas que no solo atraen la atención, sino que también dejan una huella duradera en la mente de la audiencia.",
  },
  {
    id: 2,
    desc: "Mentes creativas, estrategas astutos y profesionales dedicados se unen para ofrecer soluciones que destacan en un paisaje publicitario dinámico. Buscamos la excelencia en cada detalle para superar las expectativas y forjar un camino hacia el éxito.",
  },
  {
    id: 3,
    desc: "Impulsados por la excelencia, perfeccionamos cada acción, desde la gestación de ideas hasta la ejecución de campañas. Superamos expectativas con orgullo, entregando resultados que trascienden.",
  },
  {
    id: 4,
    desc: "Creemos en el poder transformador de la publicidad, esforzándonos no solo por el éxito comercial, sino también por contribuir al bienestar social y ambiental, guiando nuestra práctica hacia un impacto positivo duradero.",
  },
];
